import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20digital%20reading%20platform%20with%20warm%20cozy%20atmosphere%2C%20bookshelf%20filled%20with%20colorful%20comic%20books%2C%20soft%20warm%20ambient%20lighting%2C%20modern%20minimalist%20interior%2C%20artistic%20illustration%20style%20with%20gentle%20bokeh%20effect%2C%20relaxing%20reading%20nook%20aesthetic&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="韩漫之家 - 免费下拉式漫画在线阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 text-center">
        <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 leading-tight mb-4">
          韩漫之家 — 你的专属韩漫阅读空间
        </h1>
        <p className="text-base md:text-lg text-background-50/85 max-w-xl mx-auto mb-8 leading-relaxed">
          专业的<strong>韩漫网站</strong>，专注免费<strong>下拉式漫画在线观看</strong>，
          智能加载技术让每一页都流畅舒适，海量热门韩漫每日更新。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-lg hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
          >
            <i className="ri-book-read-line mr-2"></i>
            立即阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 text-background-50 text-sm font-medium rounded-lg hover:bg-background-50/25 backdrop-blur-sm transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-50/20"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}